import Pagination from '@material-ui/lab/Pagination';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { NA } from '../../../components/constants/constants';
import { isNull } from '../../../services/util-service';
import { getLeaderBoardGroup, getRankGroup } from '../group.service';
import './group-leaderboard.styles.scss';

const GroupLeaderboard = (props) => {

  const groupId = props.groupId;
  const date = props.date;
  const history = useHistory();
  const [myRank, setMyRank] = useState(null);
  const [leaderboardInfo, setLeaderboardInfo] = useState(null);
  const [toppersInfo, setToppersInfo] = useState([]);
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(1);


  useEffect(() => {
    setToppersInfo([]);
    searchLeaderboard();
  }, []);

  useEffect(() => {
    loadLeaderBoard();
  }, [page]);

  const handleChange = (event, value) => {
    setPage(value);
  };

  const searchLeaderboard = () => {
    loadLeaderBoard();
    loadRank();
  }

  const loadLeaderBoard = () => {
    const currDate = isNull(date) ? moment() : moment(date);
    const month = currDate.format('M');
    const year = currDate.format('yyyy');
    getLeaderBoardGroup(year, month, groupId, page - 1).subscribe({
      next: (response) => {
        setLeaderboardInfo(response.data.data);
        // Extract toppers info in the first page
        if (page === 1 && response.data.data.length > 0) {
          let tempToppersInfo = [];
          for (let i = 0; i < 3; i++) {
            if (response.data.data[i]) {
              tempToppersInfo.push(response.data.data[i]);
            }
          }
          setToppersInfo([...tempToppersInfo])
        }
        setPageCount(response.data.totalPages);
      }
    });
  }

  const loadRank = () => {
    const currDate = isNull(date) ? moment() : moment(date);
    const month = currDate.format('M');
    const year = currDate.format('yyyy');
    getRankGroup(year, month, groupId).subscribe({
      next: (response) => {
        setMyRank(response.data);
      }, error: (error) => {
        const tempRank = { ...myRank };
        tempRank.rank = NA;
        tempRank.score = NA;
        tempRank.point = NA;
        setMyRank(tempRank);
      }
    });
  }

  const renderMedal = (rank) => {
    if (rank === 1) {
      return (<img src="/assets/images/leaderboard/gold.png" alt="" />);
    } else if (rank === 2) {
      return (<img src="/assets/images/leaderboard/silver.png" alt="" />);
    } else if (rank === 3) {
      return (<img src="/assets/images/leaderboard/bronze.png" alt="" />);
    } else {
      return (<img src="/assets/images/leaderboard/noMedal.png" alt="" />);
    }

  }

  // const rankingFilters = () => {
  //   if (gradeList.length === 0) {
  //     return (
  //       <div className="leaderboard-filters">
  //         <div className="leaderboard-loading">Loading...</div>
  //       </div>
  //     )
  //   } else {
  //     return (
  //       <div className="leaderboard-filters">
  //         {
  //           gradeList.map((grade, idx) => (
  //             <div key={idx} className={grade.grade === currentGrade ? "leaderboard-filter-button active-grade" : "leaderboard-filter-button"} onClick={() => { selectGrade(grade.grade) }}>Class-{grade.grade}</div>
  //           ))
  //         }
  //       </div>
  //     )
  //   }
  // }

  const rankingBoard = () => {
    if (leaderboardInfo === null) {
      return (
        <div className="leaderboard-toppers">
          <div className="leaderboard-loading">Loading...</div>
        </div>
      )
    } else {
      if (leaderboardInfo.length === 0) {
        return (<div className="leaderboard-no-ranking">No ranking as of now.</div>)
      } else {
        return (
          <>
            {/* {rankingToppers()} */}
            {rankingPersonal()}
            {rankingList()}
          </>
        )
      }
    }
  }

  const rankingToppers = () => {
    if (toppersInfo.length === 0) {
      return (
        <div className="leaderboard-toppers">
          <div className="leaderboard-loading">Loading...</div>
        </div>
      )
    } else {
      return (
        <div className="leaderboard-toppers">
          {
            toppersInfo.map((rankInfo, idx) => {
              return (
                <div key={idx} className="leaderboard-toppers-card">
                  <div className="toppers-medal">
                    {renderMedal(rankInfo.rank)}
                  </div>
                  <div className="toppers-image">
                    <img src={rankInfo.imgPath} alt="" />
                  </div>

                  {/* <div className="toppers-rank">
                    <span># </span>
                    {rankInfo.rank}
                  </div> */}
                  <div className="toppers-name">
                    {rankInfo.name}
                  </div>
                  {/* <div className="toppers-info">
                    <div className="toppers-quiz"><span>Quizzes </span>{rankInfo.quizCount}</div>
                    <div className="toppers-score"><span>Score </span>{rankInfo.score}</div>
                  </div> */}
                </div>
              )
            }
            )
          }
        </div>
      )
    }
  }

  const rankRow = (rankInfo, showBorder = false, idx) => {
    return (
      <div key={idx} className="leaderboard-rankRow" style={showBorder ? { borderBottom: "1px solid #ccc" } : null}>
        <div className="rankRow-left">
          <div className="leaderboard-rankRow-rank">
            {rankInfo.rank}
          </div>
          <div className="leaderboard-rankRow-image">
            <img src={rankInfo.imgPath} alt="" />
          </div>
          <div className="leaderboard-rankRow-info">
            <div>{rankInfo.name}</div>
            <div className="leaderboard-rankRow-info-details">
              Points: {rankInfo.point}
            </div>
          </div>
        </div>
        <div className="rankRow-right">
          <div className="leaderboard-rankRow-medal">
            {renderMedal(rankInfo.rank)}
          </div>
        </div>
      </div>
    )
  }
  const rankingPersonal = () => {
    if (myRank === null || myRank.rank === 'NA' || myRank.rank === 'N/A') {
      return null;
    } else {
      return (
        <div className="leaderboard-my-rank">
          <div className="my-rank-image">
            <img src={myRank.imgPath} alt="" />
          </div>
          <div className="my-rank-info">
            <div className="my-rank-name"><span>{myRank.rank}</span>Your Rank</div>
            <div className="my-rank-score"><span>{myRank.point}</span>Your Points</div>
          </div>
        </div>
      )
    }
  }

  const rankingList = () => {
    return (
      <div className="leaderboard-rank-list">
        {leaderboardInfo.map((rankDetails, idx) => rankRow(rankDetails, true, idx))}
        <div className="leaderboard-rank-list-pagination"><Pagination count={pageCount} page={page} onChange={handleChange} variant="outlined" color="secondary" /></div>
      </div>
    )
  }

  const getMonthYear = () => {
    const currDate = isNull(date) ? moment() : moment(date);
    return currDate.format('MMMM YYYY');
  }

  return (
    <div className="group-leaderboard-container">
      {/* <Hidden only={['xs', 'sm']}>
          <Grid item xs={0} sm={0} md={4} lg={5} xl={5}>
            <div className="leaderboard-image">
              <img src="/assets/images/leaderboard/leaderboard.png" alt="Leaderboard Banner Image"></img>
            </div>
          </Grid>
        </Hidden> */}
      <div className="month-year">
        <span> {getMonthYear()}</span>
      </div>
      <div className="leaderboard-list-container">
        {/* {rankingFilters()} */}
        {rankingBoard()}
      </div>
    </div>
  );

}

export default GroupLeaderboard;